import React, { useCallback } from 'react'
import { CustomTable, Button, Loading, Popup } from 'src/components'
import GenotyRegister from './Register'
import { useStyles } from './styles'
import { Download, Filter } from 'src/assets/svg'
import { more } from 'src/assets/png'
import { PageTitle } from 'src/components/PageTitle'
import { useFilterToggler } from 'src/components/CustomTable/hooks/useFilterToggler'
import { useGenotyping } from './hooks/useGenotyping'
import { GenotypingDto } from 'src/dto/genotyping.dto'
import { useGenotypingTableHeader } from './hooks/useGenotypingTableHeader'

export const Genotyping: React.FC = () => {
  const style = useStyles()

  const { tableHeader } = useGenotypingTableHeader()
  const { filterIsActive, handleFilter } = useFilterToggler()

  const {
    isLoading,
    genotypingItemIsOpen,
    genotypingItem,
    genotypingDataList,
    setGenotypingItem,
    setGenotypingItemIsOpen,
    handleExportData,
    handleFilteredDataChange,
    handleItemDetailModal
  } = useGenotyping()

  const handleTableFilterChange = useCallback(
    (filteredData: { filterValue: string; filteredList: GenotypingDto[] }) => {
      handleFilteredDataChange(filteredData)
    },
    [handleFilteredDataChange]
  )

  return (
    <>
      <div className={style.genotypingHeader}>
        <div className={style.genotypingHeaderContent}>
          <PageTitle title='Genotipagem' />
          <div className={style.genotypingHeaderBtnContainer}>
            <Button secondary onClick={handleExportData} disabled={!genotypingDataList?.length} outlined>
              <Download className='icon' />
              EXPORTAR
            </Button>

            <Button secondary disabled={!genotypingDataList?.length} onClick={handleFilter} outlined>
              <Filter className='icon' />
              FILTRAR
            </Button>

            <Button
              className={style.buttonWrapper}
              onClick={() => {
                setGenotypingItem(null)
                setGenotypingItemIsOpen(true)
              }}
            >
              <img src={more} alt='Incluir' />
              CADASTRAR
            </Button>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <div className={style.genotypingContainer}>
          <CustomTable
            filterIsActive={filterIsActive}
            body={genotypingDataList!}
            header={tableHeader}
            filterPlaceholder='Série, Nome, Sexo...'
            propertiesToFilter={[
              'codigoBarras',
              'animal.serie',
              'animal.rgn',
              'animal.rgd',
              'animal.dataNascimento',
              'animal.nome',
              'animal.sexo',
              'animal.cat',
              'animal.var'
            ]}
            onClickItem={(item) => handleItemDetailModal(item as GenotypingDto)}
            onFilteredDataChange={handleTableFilterChange}
          />
          {genotypingItemIsOpen && (
            <Popup
              className={style.usersPopup}
              title='Cadastrar Genotipagem'
              onClose={() => setGenotypingItemIsOpen(false)}
              closeOnClickOutside={false}
            >
              <GenotyRegister data={genotypingItem} onClose={() => setGenotypingItemIsOpen(false)} />
            </Popup>
          )}
        </div>
      )}
    </>
  )
}
